"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _default = exports.default = {
  name: 'YsQuarterPicker',
  props: {
    value: {
      type: [String, Object],
      default: undefined
    },
    open: {
      type: Boolean,
      default: undefined
    },
    disabledQuarter: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      selectedYear: undefined,
      selectedQuarter: undefined,
      internalOpen: false
    };
  },
  computed: {
    modelOpen: {
      get() {
        return this.open !== undefined ? this.open : this.internalOpen;
      },
      set(val) {
        if (this.open !== undefined) {
          this.$emit('update:open', val);
        } else {
          this.internalOpen = val;
        }
      }
    },
    showValue() {
      const {
        selectedYear,
        selectedQuarter
      } = this;
      if (selectedYear && selectedQuarter) {
        return `${selectedYear}-Q${selectedQuarter}`;
      }
      return '请选择';
    }
  },
  watch: {
    value: {
      handler(value) {
        this.selectedYear = value ? (0, _moment.default)(value).year() : (0, _moment.default)().year();
        this.selectedQuarter = value ? (0, _moment.default)(value).quarter() : undefined;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    document.addEventListener('click', this.close, true);
  },
  destroyed() {
    document.removeEventListener('click', this.close);
  },
  methods: {
    handleClick() {
      if (this.open === undefined) {
        this.internalOpen = !this.internalOpen;
      } else {
        this.$emit('update:open', !this.open);
      }
    },
    close(e) {
      if (!this.$refs?.dropDownRef?.contains(e.target) && this.modelOpen) {
        this.modelOpen = false;
        this.$emit('cancel');
      }
    },
    decreaseYear() {
      this.selectedYear--;
    },
    increaseYear() {
      this.selectedYear++;
    },
    selectQuarter(quarter) {
      const value = (0, _moment.default)().year(this.selectedYear).quarter(quarter).startOf('quarter').format('YYYY-MM-DD HH:mm:ss');
      this.$emit('input', value);
      this.$emit('change', value);
      this.modelOpen = false;
    },
    isActive(quarter, year) {
      if (!this.value) {
        return false;
      }
      const current = (0, _moment.default)().year(year).quarter(quarter).startOf('quarter');
      const selectedDate = (0, _moment.default)(this.value).startOf('quarter');
      return current.isSame(selectedDate);
    }
  }
};